<template>
  <section class="section-last-added-posts">
    <div class="container">
      <ul class="last-added-posts">
        <TestDrivePost :posts="posts"/>
        <LastAddedPost :post="post" v-for="post in lastAddedPosts" :key="post.id"/>
      </ul>
    </div>
  </section>
</template>

<script>
import convertDate from "@/helpers/convertDate";
import convertCategory from "@/helpers/convertCategory";

import TestDrivePost from './postTestDrive'
import LastAddedPost from './postLastAdded'

// Routes Names
import {blog} from '@/staticData/routesName/blog'
import getBlogImg from "@/helpers/getBlogImg";
export default {
  components: {
    TestDrivePost,
    LastAddedPost
  },
  props: {
    posts: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    convertPosts() {
      const testDriveCategory = 3
      const filteredPosts = this.posts.filter((post) => post.category_id !== testDriveCategory)
      
      return filteredPosts.map(post => {
        const category = convertCategory(post.category_id);
        const linkCat = `${blog}/${category.url}`;

        return {
          id: post.id,
          title: post.title,
          description: post.description,
          img: getBlogImg(post.img && post.img.file_name),
          slug: post.slug,
          category: category.title,
          linkCat,
          link: `${linkCat}/${post.id}`,
          date: convertDate(post.created)
        };
      });
    },
    lastAddedPosts() {
      const limit = 5;
      const length = this.convertPosts.length;

      if (length <= limit) return [...this.convertPosts].reverse();

      const lastAddedPosts = this.convertPosts.slice(length - limit, length);
      return lastAddedPosts.reverse();
    }
  }
};
</script>
